import { BehaviorSubject } from 'rxjs';
import { RaiseSupportComponent } from './../../components/raise-support/raise-support.component';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, ViewChild } from '@angular/core';
import { GetSupportRequestService } from '../../services/get-support-request.service';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MediaService } from 'src/app/shared/modules/services/media.service';
import { LoginService } from 'src/app/core/services/login.service';
import { UpdateSupportRequestsService } from 'src/app/modules/dashboard/modules/support-management/services/update-support-requests.service';
import { ToastService } from 'src/app/core/toast.service';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';
import { Tables } from 'src/app/shared/enum/tables.enum';
import { Overlay } from '@angular/cdk/overlay';
import { DocumentViewerComponent } from 'src/app/modules/dashboard/modules/my-directory/pages/document-viewer/document-viewer.component';

@Component({
  selector: 'app-support-center',
  templateUrl: './support-center.component.html',
  styleUrls: ['./support-center.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({
        height: '0px',
        opacity: 0,
        overflow: 'hidden',
        padding: '0px'
      })),
      state('expanded', style({
        height: '*',
        opacity: 1,
        overflow: 'hidden'
      })),
      transition('collapsed <=> expanded', [
        animate('300ms ease')
      ])
    ])
  ]
})
export class SupportCenterComponent implements OnInit {
  filterForm = this.fb.group({
    status: ['OPEN', [Validators.required]],
    search: [null, [Validators.required]],
    limit:[10],
    offset: [0]
  })

raiseSupportForm = this.fb.group({
  message: [null, Validators.required],
  attachments: [[], []],
});


  @ViewChild('chatBody') chatBody: any;
 conversationData: any[] = [];
 conversationLoading: boolean = false;
 supportId : string;
  isExpanded = false;
  commentAttachSelectedFiles: any[] = [];
  filterSubject = new BehaviorSubject(this.filterForm.value);
  totalElements = 0;
  supportRequestListing: any[];
  selectedSupportRequest: any;
  loginData:any;
    isUserAtBottom = true;
  constructor(
    private fb: FormBuilder,
    private _dialog: MatDialog,
    private getSupportRequestService: GetSupportRequestService,
    private loginService: LoginService,
    private updateSupportRequestsService: UpdateSupportRequestsService,
    private toast: ToastService,
    private mediaService: MediaService,
    private commonService: CommonServicesForAllModules,
     private overlay: Overlay,
  ) { }


  ngOnInit(): void {

    this.loginData = this.loginService.getLoginData();
    this.search.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => {
          this.filterSubject.next(this.filterForm.value); 
        })
      )
      .subscribe();

    this.status.valueChanges
      .pipe(
        tap(() => {
          this.filterSubject.next(this.filterForm.value);
        })
      )
      .subscribe();

    this.filterSubject
      .pipe(
        switchMap(filterData => {
          this.supportRequestListing = null;
          return this.getSupportRequestService.getSupportRequests(filterData);
        })
      )
     .subscribe(([support_requests, count]: any) => {
  this.supportRequestListing = support_requests;
  this.totalElements = count;

  if (support_requests && support_requests.length > 0) {

    this.selectedSupportRequest = support_requests[0];
    this.supportId = support_requests[0].id;

    this.GetSupportRequestsConversationData();
  }
});
 
  }

  ngAfterViewInit() {
  setTimeout(() => this.scrollToBottom(), 200);
}

scrollToBottom() {
  if (!this.isUserAtBottom) return; 

  try {
    this.chatBody.nativeElement.scrollTop =
      this.chatBody.nativeElement.scrollHeight;
  } catch (err) {}
}


  toggleMessage() {
    this.isExpanded = !this.isExpanded;
  }

 GetSupportRequestsConversationData() {

  if (!this.supportId) return;

  this.conversationLoading = true; 

  this.updateSupportRequestsService
    .getSupportRequestsConversationData(this.supportId)
    .subscribe({
      next: (res: any) => {
        this.conversationData = res.data.support_requests_conversations || [];
        this.conversationLoading = false; 
        setTimeout(() => this.scrollToBottom(), 100);
      },
      error: (err) => {
        console.error("Conversation Load Error:", err);

        this.conversationData = []; 
        this.conversationLoading = false;
        this.toast.openSnackBar('Failed to load conversation');
      }
    });
}

commentFileSelected(event: any) {
  const files = event.target.files;
  if (!files || files.length === 0) return;

  Array.from(files).forEach((file: File) => {
    const formData = new FormData();
    formData.append('directory', 'project');
    formData.append('file', file);

    this.mediaService.uploadMedia(formData).subscribe(response => {
      if (response && response.url) {
        
        const fileObj = {
          name: file.name,
          type: file.type.startsWith('video') ? 'video' :
                file.type.startsWith('image') ? 'image' : file.type,
          url: response.url,
          extension: response.extension || file.name.split('.').pop()
        };

        this.commentAttachSelectedFiles.push(fileObj);
        const array = [...this.raiseSupportForm.value.attachments];
        array.push(fileObj);
        this.raiseSupportForm.patchValue({ attachments: array });
      }

    }, error => {
      console.error("Upload failed:", error);
    });
  });

  event.target.value = '';
}


 removeFile(index: number) {
  this.commentAttachSelectedFiles.splice(index, 1);

  const array = [...this.raiseSupportForm.value.attachments];
  array.splice(index, 1);
  this.raiseSupportForm.patchValue({ attachments: array });
}

  
async sendReply() {

  const replyMessage = this.raiseSupportForm.value.message;
  const replyAttachments = this.raiseSupportForm.value.attachments || [];

  if (replyAttachments.some(a => a.isUploading)) {
    this.toast.openSnackBar("Please wait, files are still uploading...");
    return;
  }

  if (!replyMessage || replyMessage.trim() === "") {
    this.toast.openSnackBar("Please enter a message");
    return;
  }

  const conversation = {
    support_request_id: this.selectedSupportRequest.id,
    support_request_number: this.selectedSupportRequest.support_request_number,
    sender_id: this.loginData.id,
    sender_type: this.loginData.type,
    message: replyMessage.trim(),
    attachments: replyAttachments,
     created_at: new Date() 
  };

  await this.updateSupportRequestsService.addSupportConversation(conversation);

  this.conversationData = [...(this.conversationData || []), conversation];
  setTimeout(() => this.scrollToBottom(), 50);
  
  this.toast.openSnackBar("Message sent successfully!");

  this.raiseSupportForm.reset({
    message: null,
    attachments: []
  });

    this.commentAttachSelectedFiles = [];
}

openMsgAttachments(files: any[], index: number = 0): void {
  if (!files || !files.length) {
    this.toast.openSnackBar('No attachment found');
    return;
  }
  const documents = files.map((file: any) => ({
    url: file.url,
    name: file.name,
    type: file.type || file.mime_type,
    mime_type: file.mime_type || file.type
  }));

  this._dialog.open(DocumentViewerComponent, {
    width: '70vw',
    scrollStrategy: this.overlay?.scrollStrategies?.noop(),
    data: {
      documents,
      initialIndex: index
    },
    panelClass: 'doc-viewer-dialog'
  });
}

  raiseSupport() {
    const dialogRef = this._dialog.open(RaiseSupportComponent, {
      width: '35%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'], 
      disableClose: true,
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      data: { type: "GENERAL" }
    });
    dialogRef.afterClosed().subscribe(data=>{
      if(data === 'yes'){
        this.filterSubject.next(this.filterForm.value);
      }
    })
  }
  selectRequest(selectRequest: any){
    this.selectedSupportRequest = selectRequest;
    this.supportId = selectRequest.id;
    this.isExpanded = false;
    this.conversationLoading = true;
    this.GetSupportRequestsConversationData();
  }
  /* --------------------------------- Getters -------------------------------- */
  get status(): FormControl {
    return this.filterForm.get('status') as FormControl;
  }
  get search(): FormControl {
    return this.filterForm.get('search') as FormControl;
  }
  get limit(){
    return this.filterForm.get('limit');
  }
  get offset(){
    return this.filterForm.get('offset');
  }
  setSearch(){
    this.filterSubject.next(this.filterForm.value);
  }
  setStatus(){
    this.filterSubject.next(this.filterForm.value);
  }
}
